import React, { useState, useContext } from 'react';
import CreatableSelect from 'react-select/creatable';
import { routes, PageContext } from 'gatsby-theme-apollo';
import { navigate } from 'gatsby';
import { ContentBox } from '../layout/content-box';

const GameSearch = ({ games, targetPageType }) => {
  const [searchedUnsupportedGame, setSearchedUnsupportedGame] = useState(false);
  const { logEvent } = useContext(PageContext);

  const onSelectedGame = (searchedGameName, supported) => {
    setSearchedUnsupportedGame(!supported);
    logEvent('game_search', { searchedGameName, supported, targetPageType });
    if (supported) {
      const targetRoute =
        targetPageType === 'game_hub'
          ? routes.GameHub(searchedGameName)
          : routes.TierListEditor(searchedGameName);
      navigate(targetRoute);
    }
  };

  const gameOptions = games.map(({ name }) => {
    return {
      value: name,
      label: name
    };
  });

  const customStyles = {
    option: provided => ({
      ...provided,
      borderBottom: '1px solid #333',
      color: `white`,
      backgroundColor: `black`
    }),
    input: provided => {
      return {
        ...provided,
        color: `white`,
        backgroundColor: `#222`
      };
    },
    menu: () => {
      return {
        backgroundColor: `black`
      };
    },
    container: provided => {
      return {
        ...provided,
        backgroundColor: `black`,
        maxWidth: `600px`,
        margin: `0px auto`
      };
    },
    control: provided => {
      return { ...provided, border: `1px solid #333`, backgroundColor: `#222` };
    },
    singleValue: provided => {
      return { ...provided, color: `white` };
    }
  };

  return (
    <>
      {searchedUnsupportedGame && (
        <ContentBox
          solidBackground
          style={{ width: `100%`, textAlign: `center`, margin: `0px auto` }}
        >
          Sorry, we don&rsquo;t support that game yet, but we&rsquo;ll work on it for you! Join
          our&nbsp;
          <a href="https://discord.gg/WWgcW8Z" rel="noopener noreferrer">
            Discord
          </a>
          &nbsp;and yell at us to speed things up. :)
        </ContentBox>
      )}
      <CreatableSelect
        aria-label="Game Search"
        onCreateOption={gameName => onSelectedGame(gameName, false)}
        onChange={game => onSelectedGame(game.label, true)}
        options={gameOptions}
        isClearable
        isSearchable
        styles={customStyles}
        placeholder="Select or Search"
      />
    </>
  );
};

export default GameSearch;
